import { useDroppable } from '@dnd-kit/core';
import { Trash2 } from 'lucide-react';
import { Button } from './ui/button';

export default function FolderItem({ id, name, icon, isActive, onClick, onDelete, count = 0 }) {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
  });

  return (
    <div
      ref={setNodeRef}
      onClick={onClick}
      className={`folder-item group ${isActive ? 'active' : ''} ${isOver ? 'drop-target' : ''}`}
      data-testid={`folder-${id}`}
    >
      <span className={`${isActive ? 'text-amber-500' : 'text-stone-400'}`}>
        {icon}
      </span>
      <span className={`flex-1 font-lato text-sm ${isActive ? 'text-amber-500' : 'text-stone-300'}`}>
        {name}
      </span>
      <span className="text-xs text-stone-500 bg-stone-800 px-2 py-0.5 rounded">
        {count}
      </span>
      {onDelete && (
        <Button
          variant="ghost"
          size="icon"
          onClick={(e) => { e.stopPropagation(); onDelete(); }}
          className="h-6 w-6 opacity-0 group-hover:opacity-100 text-stone-500 hover:text-red-500"
          data-testid={`delete-folder-${id}`}
        >
          <Trash2 className="w-3 h-3" />
        </Button>
      )}
    </div>
  );
}
